import { KmzUploadErrorReason } from '~/common/posthogEvents';

export type KmzUploadError = { reason: KmzUploadErrorReason; message: string };

// reason is the low-cardinality key the PostHog catalog groups failures by; message is what the
// user sees, and for too_many_segments it interpolates a count that would be useless to group on.
export const errors = {
  general: {
    reason: KmzUploadErrorReason.General,
    message: 'An error occurred while uploading your KMZ/KML file, please contact support.',
  },
  missingFile: { reason: KmzUploadErrorReason.MissingFile, message: 'No file selected' },
  noContent: { reason: KmzUploadErrorReason.NoContent, message: 'No content found in KMZ/KML file.' },
  noFeatures: {
    reason: KmzUploadErrorReason.NoFeatures,
    message:
      'There are no valid segments in the uploaded file. Import a KMZ/KML containing either all line segments or all polygon segments',
  },
  mixedGeometryTypes: {
    reason: KmzUploadErrorReason.MixedGeometryTypes,
    message:
      'CivilGrid does not support mixed geometry types for projects. Upload a KMZ/KML that contains either all lines or all polygons.',
  },
  invalidGeometryType: {
    reason: KmzUploadErrorReason.InvalidGeometryType,
    message: 'Invalid geometry type found in KMZ/KML file. Geometry must be either polygon or line.',
  },
  invalidPolygonGeometry: {
    reason: KmzUploadErrorReason.InvalidPolygonGeometry,
    message: 'Invalid polygon geometry found in KMZ/KML file. Ensure all polygons in the KMZ/KML are valid geometry.',
  },
  invalidLineStringGeometry: {
    reason: KmzUploadErrorReason.InvalidLineStringGeometry,
    message: 'Invalid line geometry found in KMZ/KML file. Ensure all lines are valid geometry.',
  },
  tooManySegments: (segmentCount: number, maxSegments: number) => ({
    reason: KmzUploadErrorReason.TooManySegments,
    message: `This KMZ/KML contains ${segmentCount} segments, which exceeds the current project limit of ${maxSegments} segments. Try again with fewer segments.`,
  }),
} as const satisfies Record<string, KmzUploadError | ((...args: never[]) => KmzUploadError)>;
